import { render, staticRenderFns } from "./BindDialog.vue?vue&type=template&id=adf865e6&scoped=true"
import script from "./BindDialog.vue?vue&type=script&lang=js"
export * from "./BindDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf865e6",
  null
  
)

export default component.exports